export default "__VITE_ASSET__oyupsgWr__"